import React from 'react';
import { MDBDataTable } from 'mdbreact';
import '../../style/DataTable.css';

const ClubMembersDataTable = (props) => {
  const getClubMembersData = () => {
    let rowData = [];
    props.clubMembers.map((row) =>
      rowData.push({
        clubName: row.clubName ? row.clubName : 'N/A',
        playerName: row.playerName ? row.playerName : 'N/A',
        teamName: row.teamName ? row.teamName : 'N/A',
        isCaptain: row.isCaptain ? '(K)' : '',
        competitionClass: row.competitionClass ? row.competitionClass : '',
      })
    );
    if (!rowData.length) {
      return null;
    }

    rowData.sort((first, second) => {
      if (first.clubName === second.clubName) {
        if (first.teamName === second.teamName) {
          return first.playerName.localeCompare(second.playerName, 'et');
        }
        return first.teamName.localeCompare(second.teamName, 'et');
      }
      return first.clubName.localeCompare(second.clubName, 'et');
    });

    return {
      columns: [
        {
          label: 'Klubi',
          field: 'clubName',
        },
        {
          label: 'Liige',
          field: 'playerName',
        },
        {
          label: 'Võistkond',
          field: 'teamName',
        },
        {
          label: 'Kapten',
          field: 'isCaptain',
        },
        {
          label: 'Võistlusklass',
          field: 'competitionClass',
        },
      ],
      rows: rowData,
    };
  };
  const tableData = getClubMembersData();

  return (
    <div>
      {tableData ? (
        <MDBDataTable
          responsive
          small
          striped
          hover
          noBottomColumns
          data={tableData}
          paginationLabel={['<', '>']}
          noRecordsFoundLabel={'Tulemusi ei leitud'}
          infoLabel={['Näitan', '-', 'kokku', 'kirjest']}
          entriesLabel={'Näita korraga'}
          entriesOptions={[10, 25, 50, 100, 200]}
          entries={props.entries ? props.entries : 10}
          searchLabel={'Otsi'}
          bordered={false}
          paging={!!props.paging}
          searching={!!props.searching}
          sortable={!!props.sortable}
          order={!!props.order ? props.order : []}
        />
      ) : (
        <div style={{ marginTop: '25px' }}>Info puudub</div>
      )}
    </div>
  );
};

export default ClubMembersDataTable;
